// API URL configuration for routing requests to correct API Gateway

const MAIN_API_URL = (import.meta as any).env.VITE_API_URL?.replace(/\/$/, '') || 'https://ltp1ccays5.execute-api.us-east-1.amazonaws.com/prod';
const ADMIN_API_URL = (import.meta as any).env.VITE_ADMIN_API_URL?.replace(/\/$/, '') || MAIN_API_URL;

/**
 * Get the appropriate API URL based on the request path
 * @param path - The API path (e.g., '/admin/campaigns' or '/catalog')
 * @returns The full API URL to use for the request
 */
export function getApiUrl(path: string): string {
  // Admin endpoints go to Admin API
  if (path.startsWith('/admin')) {
    return ADMIN_API_URL;
  }
  
  // All other endpoints go to Main API
  return MAIN_API_URL;
}

/**
 * Get the full API endpoint URL
 * @param path - The API path
 * @returns The complete URL including the API base and path
 */
export function getFullApiUrl(path: string): string {
  return `${getApiUrl(path)}${path}`;
}

export { MAIN_API_URL, ADMIN_API_URL };
